var _ellipse, _path, _ellipse2, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapperError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 104,
    viewBox: "0 0 113 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 53,
    rx: 51.5,
    ry: 51,
    fill: "#FF4B62",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3631 103.81C31.8697 103.81 8.7041 80.9517 8.7041 52.854C8.7041 24.7564 31.8697 1.89795 60.3631 1.89795C88.8566 1.89795 112.033 24.7564 112.033 52.854C112.033 80.9517 88.8531 103.81 60.3631 103.81ZM60.3631 2.60215C32.2588 2.60215 9.40513 25.1437 9.40513 52.854C9.40513 80.5644 32.2588 103.106 60.3631 103.106C88.4675 103.106 111.332 80.5715 111.332 52.854C111.332 25.1366 88.4675 2.60215 60.3631 2.60215Z",
    fill: "#FF4B62",
    fillOpacity: 0.75
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5,
    cy: 51,
    rx: 51.5,
    ry: 51,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6695 103.81C23.1796 103.81 0 80.5256 0 51.9068C0 23.288 23.1796 0 51.6695 0C80.1595 0 103.343 23.2845 103.343 51.9068C103.343 80.5291 80.1595 103.81 51.6695 103.81ZM51.6695 0.704203C23.5652 0.704203 0.701032 23.6753 0.701032 51.9068C0.701032 80.1383 23.5652 103.106 51.6695 103.106C79.7739 103.106 102.642 80.1383 102.642 51.9068C102.642 23.6753 79.7739 0.704203 51.6695 0.704203Z",
    fill: "#FF4B62"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 -0.420299 0.58411 0.811674 37 36)",
    fill: "#FF4B62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 -0.420299 0.58411 0.811674 37 36)",
    fill: "#FF4B62"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 -0.420299 0.58411 0.811674 37 36)",
    fill: "#FF4B62"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 0.420299 -0.58411 0.811674 60.6826 34)",
    fill: "#FF4B62"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 0.420299 -0.58411 0.811674 60.6826 34)",
    fill: "#FF4B62"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.75852,
    height: 40.5445,
    rx: 2.37926,
    transform: "matrix(0.907386 0.420299 -0.58411 0.811674 60.6826 34)",
    fill: "#FF4B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapperError);
export default __webpack_public_path__ + "static/media/icon-mapper-error.8dc1c6bcb2e7f5239b714de8c6627d47.svg";
export { ForwardRef as ReactComponent };